import { useState } from "react";
import { Undo2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { AddReturnDialog } from "@/modules/orders/returns/AddReturnDialog";

/**
 * "Add a return" in the order's actions (#594): the same action as on Returns
 * to receive, opened already searching for this order. The caller decides
 * whether to show it (the permission, and an order that is not cancelled).
 */
export function AddReturnAction({ orderNumber }: { orderNumber: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={() => {
          setOpen(true);
        }}
      >
        <Undo2 aria-hidden />
        Add a return
      </Button>
      {open ? (
        <AddReturnDialog
          open
          onOpenChange={setOpen}
          initialOrderNumber={orderNumber}
        />
      ) : null}
    </>
  );
}
